import { Coupon } from '@dtx-company/true-common/src/types/Coupon'
import { PlanPurchaseExperienceSummaryLineContainer } from './PlanPurchaseExperienceSummaryLineContainer'
import { PlanPurchaseExperienceSummaryLineLabel } from './PlanPurchaseExperienceSummaryLineLabel'
import { PlanPurchaseExperienceSummaryLineProps } from './PlanPurchaseExperienceSummaryLine'
import { PlanPurchaseExperienceSummaryLineValue } from './PlanPurchaseExperienceSummaryLineValue'
import { SxProps } from '@mui/material'
import { getPriceText } from '../../../../utils/getPriceText'

function getLabelText(props: PlanPurchaseExperienceSummaryLineCouponProps): string {
  if (!props.priceInCents) {
    return 'Promotion Discount (not applicable)'
  }
  if (props.promo && props.promo.percentOff) {
    return `Promotion Discount (${props.promo.percentOff}% off)`
  }
  return 'Promotion Discount'
}

export interface PlanPurchaseExperienceSummaryLineCouponProps {
  appearance: PlanPurchaseExperienceSummaryLineProps['appearance']
  priceInCents: number | undefined
  promo: Partial<Coupon> | undefined
  sx?: SxProps
}

export function PlanPurchaseExperienceSummaryLineCoupon(
  props: PlanPurchaseExperienceSummaryLineCouponProps
): JSX.Element {
  if (!props.promo) return <></>

  const labelText = getLabelText(props)
  const priceText = getPriceText({ priceInCents: props.priceInCents })

  return (
    <>
      <PlanPurchaseExperienceSummaryLineContainer sx={props.sx}>
        <PlanPurchaseExperienceSummaryLineLabel appearance={props.appearance}>
          {labelText}
        </PlanPurchaseExperienceSummaryLineLabel>
        <PlanPurchaseExperienceSummaryLineValue appearance={props.appearance}>
          {priceText}
        </PlanPurchaseExperienceSummaryLineValue>
      </PlanPurchaseExperienceSummaryLineContainer>
    </>
  )
}
